// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__17sQZ","LogoWrapper":"Loader_LogoWrapper__1MyJE","Mounted":"Loader_Mounted__2OjKY"};